<template>
	<div class="w-full h-6 bg-primary-900 text-white text-xs font-medium text-center py-1 uppercase hidden sm:block">
		LEADING PROVIDER OF DEAF SKILLS DEVELOPMENT TRAINING IN SOUTH AFRICA
	</div>
	<div class="w-full h-6 bg-primary-900 text-white text-xs font-medium text-center py-1 uppercase block sm:hidden">SOUTH AFRICAN DEAF SKILLS DEVELOPMENT</div>
</template>
